import { Component, ElementRef, OnDestroy, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBan, faChevronDown, faChevronLeft, faChevronUp, faCircle, faPlay, faRotateLeft } from '@fortawesome/pro-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DeclarationsService } from '../../../core/services/declarations/declarations.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ExecutorModalComponent } from '../../../components/executor-modal/executor-modal.component';
import { MultipleExecutorsModalComponent } from '../../../components/multiple-executors-modal/multiple-executors-modal.component';
import { faArrowRotateLeft, faPenLine, faUser, faUserPlus, faXmark, faComment } from '@fortawesome/pro-light-svg-icons';
import { FiltersService } from '../../../core/services/declarations/filters.service';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { CommentModalComponent } from '../../../components/comment-modal/comment-modal.component';
import { StatusDeclarationEnum } from '../../../core/enums/status-declaration.enum';
import { TypeChangeEnum } from '../../../core/enums/type-change.enum';
import { PresentationTypeEnum } from '../../../core/enums/presentation-type.enum';
import { FormatEnum } from '../../../core/enums/format.enum';
import { DeclarationPhasesComponent } from '../../../components/declaration-phases/declaration-phases.component';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { InputGroupModule } from 'primeng/inputgroup';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TypeDeclarationEnum } from '../../../core/enums/type-declaration.enum';
import { InputMaskModule } from 'primeng/inputmask';
import { ContractObservationsService } from '../../../core/services/contract-observations/contract-observations.service';
import { AuthService } from '../../../core/services/auth.service';
import { UtcDatePipe } from '../../../core/pipes/utc-date.pipe';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { faTriangleExclamation, faGear } from '@fortawesome/pro-solid-svg-icons';
import { faCommentExclamation } from '@fortawesome/pro-light-svg-icons';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { MenuItem } from 'primeng/api';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-declaration-detail',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, ReactiveFormsModule, RouterModule, FormsModule, PaginationComponent, DeclarationPhasesComponent, CommentModalComponent, MultipleExecutorsModalComponent, DropdownModule, InputTextModule, InfiniteScrollModule, InputGroupModule, ProgressSpinnerModule, InputMaskModule, CheckboxModule, InputTextareaModule, MenuModule, ButtonModule, UtcDatePipe],
  templateUrl: './declaration-detail.component.html',
  styleUrl: './declaration-detail.component.scss'
})
export class DeclarationDetailComponent implements OnDestroy {

  @ViewChildren('panel') panels!: QueryList<ElementRef>;
  @ViewChild('modal') modal: ExecutorModalComponent;
  @ViewChild('commentModal') commentModal: CommentModalComponent;
  @ViewChild(DeclarationPhasesComponent) declarationPhases: DeclarationPhasesComponent;

  actionMenuItems: any[] = [];

  faBan = faBan;
  faPenLine = faPenLine;
  faPlay = faPlay;
  faCircle = faCircle;
  faChevronLeft = faChevronLeft;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faUser = faUser;
  faRotateLeft = faRotateLeft;
  faRotateLeftThin = faArrowRotateLeft
  faUserPlus = faUserPlus;
  faCommentExclamation = faCommentExclamation;
  faTriangleExclamation = faTriangleExclamation;
  faXmark = faXmark;
  faComment = faComment;
  faGear = faGear;

  isAccordionOpen = false;
  hoveringExecutor = null;
  hoverTask = null;
  hoverPhase = null;

  formats = Object.values(FormatEnum)
  presentations = PresentationTypeEnum;

  responsibles = [];
  observations = [];

  declaration: any;

  configExecutorModal: any = undefined;
  showExecutorModal: boolean = false;

  configCommentModal: any = undefined;
  showCommentModal: boolean = false;

  configReactivateModal: any = undefined;
  showReactivateModal: boolean = false;

  showMultipleExecutorsModal: boolean = false;

  selectedTask = null;

  allExpanded = true;

  currentPage = 0;
  itemsForPage = 5;
  maxPages = undefined;

  user = undefined;

  decFinished = false;

  isFormatChanged = false;
  isPresentationChanged = false;
  isAccountChanged = false;
  isAccountDisabled = false;
  isAccountHidden = false;
  isNRCHidden = true;
  isNRCChanged = false;
  isPresentationDisabled = false;
  isBankAccountConfirmationCompleted = false;

  isBlocked = false;

  get clientDisplayName(): string {
    const c = this.declaration?.client;
    if (!c) return '';
    if (c.personType !== 'PHYSICAL_PERSON') return c.name ?? '';
    return (c.firstSurname ? c.firstSurname + ' ' : '') +
      (c.secondSurname ? c.secondSurname + ', ' : '') +
      (c.name ?? '');
  }
  isChangingStatus = false;
  today = new Date();

  originalBankAccount = "";
  originalNRC = "";

  commentForm = new FormGroup({
    comment: new FormControl('', Validators.required),
  });

  disableAccountPresentations = [
    "Informativa - PDF",
    "Sacich NRC - PDF",
    "Presentación cliente - PDF",
    "Presentación cliente - DAT",
    "Resultado 0.00 - PDF",
    "A compensar - PDF",
  ];

  disableNRCPresentations = [
    "Domiciliada - PDF",
    "Devolución - PDF",
    "Negativa - PDF",
    "Aplazamiento total - PDF",
  ];

  isLoading: boolean;
  isDynamic: boolean = false;

  // Contract observations  
  contractObservations: any[] = [];
  showContractObservationsModal: boolean = false;
  currentUserId: number = null;
  currentUserDepartment: string = null;
  declarationModelDepartment: string = null;
  contractObservationForm = new FormGroup({
    comment: new FormControl('', Validators.required),
  });

  constructor(
    private route: ActivatedRoute,
    private declarationService: DeclarationsService,
    private filtersService: FiltersService,
    private router: Router,
    private contractObservationsService: ContractObservationsService,
    private authService: AuthService
  ) {
    this.actionMenuItems = [];
  }
  async ngOnInit() {
    this.isLoading = true;
    this.user = this.authService.getUser()?.user;
    this.currentUserId = this.authService.getUserId();
    const currentUser = this.authService.getUser();
    this.currentUserDepartment = currentUser?.user?.department;
    const id = Number(this.route.snapshot.paramMap.get('id'));

    // Antes de getData: construye el menú de acciones, que depende de isBlocked.
    this.isBlocked = !!history.state.block;
    try {
      await this.getData(id);
    } finally {
      this.isLoading = false;
    }
  }

  ngOnDestroy() {
    // Asegurar que se limpia la clase modal-open cuando el componente se destruye
    document.body.classList.remove('modal-open');
  }

  async getData(id) {
    this.declaration = await this.declarationService.getDeclarationsById(id);
    if (!this.declaration.responsible) {
      this.declaration.responsible = { id: undefined };
    }
    this.declarationModelDepartment = this.declaration?.model?.department;
    this.isDynamic = this.declaration.model.isDynamic ? true : false;
    this.declaration.model.periodicity = this.declaration.model.name.charAt(this.declaration.model.name.length - 1)
    // Cargar observaciones del contrato
    await this.loadContractObservations();
    // Initialize bank account change detection
    const originalAccount = this.declaration?.contract?.bankAccount?.iban || '';
    this.originalBankAccount = originalAccount;
    this.isAccountChanged = this.declaration.bankAccount !== originalAccount;

    // Initialize NRC change detection
    this.originalNRC = this.declaration?.nrc || '';
    this.isNRCChanged = false;

    if (this.declaration?.contract?.presentationType || this.declaration?.declaration?.presentationType) {
      this.isPresentationChanged = this.declaration.presentationType !== (this.declaration?.contract?.presentationType || this.declaration?.declaration?.presentationType);
    }
    this.updateBankAccountVisibility();
    this.updateNRCVisibility();

    this.declaration.phases = this.declaration.phases.map(p => {
      return { ...p, show: false };
    });
    this.declaration.phases.forEach(phase => {
      phase.tasks.forEach(task => {

        if (task.value === "true") {
          task.value = true;
        }
        task.initialValue = task.value;
      });
    });

    const observations = await this.getObservations(id, this.currentPage, this.itemsForPage);
    this.maxPages = observations.totalPages;
    this.observations = observations.observations;

    const user = this.authService.getUser();
    this.responsibles = (await this.filtersService.getUsers()).filter(u => user?.user?.department !== 'GENERAL' ? u.department === user?.user?.department : u.department);
    this.declaration.phases.forEach(p => {
      p.show = true;
    });
    await this.disableTasks(this.declaration.presentationType, true);
    await this.disableTasksOnTaskChange();

    // Inicializar el menú de acciones
    this.buildActionMenu();

  }

  buildActionMenu() {
    if (!this.declaration) {
      this.actionMenuItems = [];
      return;
    }

    const isFinishedOrNotApplicable = this.declaration.status === 'NOT_APPLICABLE' || this.declaration.status === 'FINISHED';
    const isInProgress = this.declaration.status === 'PROGRESS';

    this.actionMenuItems = [
      {
        label: isFinishedOrNotApplicable ? 'Reactivar' : 'No procede',
        icon: isFinishedOrNotApplicable ? this.faRotateLeft : this.faBan,
        command: () => {
          if (this.declaration.status === 'NOT_APPLICABLE' || this.declaration.status === 'FINISHED') {
            this.openReactivateModal();
          } else {
            this.openCommentModal();
          }
        }
      },
      // Solo mostrar "Añadir aviso" si la declaración está en PROGRESS
      ...(isInProgress ? [{
        label: 'Añadir aviso',
        icon: this.faCommentExclamation,
        command: () => {
          this.openContractObservationsModal();
        }
      }] : []),
      ...(!this.isBlocked ? [
        {
          label: 'Cambiar ejecutor',
          icon: this.faUserPlus,
          command: () => {
            this.openMultipleExecutorsModal();
          }
        }
      ] : [])
    ];
  }

  scrollToCommentSection() {
    // Hacer scroll hasta la sección de comentarios y hacer focus en el textarea
    const commentTextarea = document.querySelector('.new-comment textarea') as HTMLTextAreaElement;
    if (commentTextarea) {
      commentTextarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        commentTextarea.focus();
      }, 500);
    }
  }

  async setFormat(event) {
    const format = event.value;
    this.isFormatChanged = format !== this.declaration.client.format;
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Format, change: format });
  }

  async setPresentation(event) {
    const presentation = event.value;
    this.isPresentationChanged = presentation !== this.declaration.client.presentationType;
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Presentation, change: presentation });
    await this.disableTasks(presentation);
    this.updateBankAccountVisibility();
    this.updateNRCVisibility();
    // Si Importe declaración está completada, revisar si hay que auto-rellenar otras tareas tras el cambio de tipo
    await this.declarationPhases?.runAutoFillWhenPresentationFormChanged?.();
  }

  async disableTasksOnTaskChange() {
    for (let phase of this.declaration.phases) {
      for (let task of phase.tasks) {
        if (task.disabledIfTaskDisabled) {
          let disableTask = this.declaration.phases[parseInt(task.disabledIfTaskDisabled.split('.')[0]) - 1].tasks.find(t =>
            task.disabledIfTaskDisabled === t.orderId
          );
          if (disableTask?.isDisabled) {
            if (task.isDisabled !== true) {
              task.isDisabled = true;
              await this.declarationService.disableTaskUpdate(task);
            }
          } else {
            if (task.isDisabled !== false) {
              task.isDisabled = false;
              await this.declarationService.disableTaskUpdate(task);
            }
          }
        }
        if (task.isDisabledByTask) {
          let disableTask = this.declaration.phases[parseInt(task.isDisabledByTask.split('.')[0]) - 1].tasks.find(t =>
            String(task.isDisabledByTask) === String(t.orderId)
          );
          if (disableTask?.value && !disableTask?.isDisabled) {
            if (task.disabledOnValues.includes(disableTask.value)) {
              if (task.isDisabled !== true) {
                task.isDisabled = true;
                await this.declarationService.disableTaskUpdate(task);
              }
            }
            else {
              if (task.isDisabled !== false) {
                task.isDisabled = false;
                await this.declarationService.disableTaskUpdate(task);
              }
            }
          } else {
            if (task.isDisabled !== true) {
              task.isDisabled = true;
              await this.declarationService.disableTaskUpdate(task);
            }
          }
        }
      }
    }


    this.updateBankAccountVisibility();
    this.updateNRCVisibility();

  }

  updateBankAccountVisibility() {
    if (this.declaration?.presentationType === 'A compensar - PDF') {
      const allTasks = this.declaration.phases.flatMap(p => p.tasks);
      const presentationFormTask = allTasks.find(t => t.name === 'Forma de presentación');
      if (presentationFormTask) {
        if (presentationFormTask.value === 'Aplazamiento 60-40') {
          const payment1 = allTasks.find(t => t.name === 'Forma de pago primer plazo' && t.value);
          const payment2 = allTasks.find(t => t.name === 'Forma de pago segundo plazo' && t.value);
          this.isAccountHidden = !(payment1?.value === 'Domiciliada' || payment2?.value === 'Domiciliada');
        } else {
          const visibleValues = [
            'Domiciliada',
            'Devolución',
            'Negativa',
            'Aplazamiento parcial',
            'Aplazamiento total'
          ];
          this.isAccountHidden = !visibleValues.includes(presentationFormTask.value);
        }
      } else {
        this.isAccountHidden = true;
      }
    } else {
      this.isAccountHidden = this.disableAccountPresentations.includes(this.declaration?.presentationType);
    }
  }

  updateNRCVisibility() {
    const presentationType = this.declaration?.presentationType;

    if (presentationType === 'Aplazamiento 60-40 - PDF') {
      const allTasks = this.declaration.phases.flatMap(p => p.tasks);
      const payment1 = allTasks.find(t => t.name === 'Forma de pago primer plazo' && t.value);
      const payment2 = allTasks.find(t => t.name === 'Forma de pago segundo plazo' && t.value);
      this.isNRCHidden = !(payment1?.value === 'Sacich NRC' || payment2?.value === 'Sacich NRC');
    } else if (presentationType === 'A compensar - PDF') {
      const allTasks = this.declaration.phases.flatMap(p => p.tasks);
      const presentationFormTask = allTasks.find(t => t.name === 'Forma de presentación');
      if (presentationFormTask?.value === 'Aplazamiento 60-40') {
        const payment1 = allTasks.find(t => t.name === 'Forma de pago primer plazo' && t.value);
        const payment2 = allTasks.find(t => t.name === 'Forma de pago segundo plazo' && t.value);
        this.isNRCHidden = !(payment1?.value === 'Sacich NRC' || payment2?.value === 'Sacich NRC');
      } else if (presentationFormTask?.value === 'Sacich NRC' || presentationFormTask?.value === 'Aplazamiento parcial') {
        this.isNRCHidden = false;
      } else {
        this.isNRCHidden = true;
      }
    } else {
      this.isNRCHidden = this.disableNRCPresentations.includes(presentationType);
    }
  }

  async disableTasks(presentation, isInitial = false) {
    for (let phase of this.declaration.phases) {
      for (let task of phase.tasks) {
        if (task.isDisabledByTypePresentation) {
          if (task.isDisabledByTypePresentation.includes(presentation)) {
            if (task.isDisabled !== true) {
              task.isDisabled = true;
              if (!isInitial) {
                this.declarationService.disableTaskUpdate(task);
              }
            }
          }
          else {
            if (task.isDisabled !== false) {
              task.isDisabled = false;
              if (!isInitial) {
                this.declarationService.disableTaskUpdate(task);
              }
            }
          }
        }

      }
    }
  }

  async setAccount(event) {
    const account = event.target.value;
    const accFormated = account.replace(/\s/g, "");
    const originalAccount = this.declaration?.contract?.bankAccount?.iban || '';
    this.isAccountChanged = accFormated !== originalAccount;
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Account, change: accFormated });
  }

  onAccountChange(event) {
    const account = event.target.value;
    const accFormated = account.replace(/\s/g, "");
    const originalAccount = this.declaration?.contract?.bankAccount?.iban || '';
    this.isAccountChanged = accFormated !== originalAccount;
  }

  async resetAccount(acc) {
    const iban = this.declaration.contract?.bankAccount?.iban;
    if (this.isBlocked || this.isAccountDisabled || !iban) return;
    this.declaration.bankAccount = iban;
    this.isAccountChanged = false;
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Account, change: iban });
  }

  async setNRC(event) {
    const nrc = event.target.value;
    this.isNRCChanged = nrc !== this.originalNRC;
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Nrc, change: nrc });
  }

  onNRCChange(event) {
    const nrc = event.target.value;
    this.isNRCChanged = nrc !== this.originalNRC;
  }

  async resetNRC() {
    this.declaration.nrc = this.originalNRC;
    this.isNRCChanged = false;
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Nrc, change: this.originalNRC });
  }


  async setResponsible(event) {
    const id = event.value;
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Responsible, change: id });
  }


  async getObservations(id, currentPage, itemsForPage) {
    return await this.declarationService.getObservationsByDeclaration(id, currentPage, itemsForPage);
  }

  showAllFases() {
    this.allExpanded = !this.allExpanded;
    if (this.allExpanded) {
      this.declaration.phases.forEach(p => {
        p.show = true;
      });
    } else {
      this.declaration.phases.forEach(p => {
        p.show = false;
      });
    }
  }

  async commentAdd(comment?) {
    let observation = {
      declaration: this.declaration.id,
      comment: comment ? comment : this.commentForm.value.comment
    }
    await this.declarationService.createObservation(observation);
    this.commentForm.reset();
    await this.getData(this.declaration.id);
  }

  getInitials(name: string): string {
    return (name ?? '').split(/\s+/).filter(Boolean).map(word => word[0].toUpperCase()).join('');
  }

  async setToNoProceed(comment) {
    if (this.isChangingStatus) return;
    this.isChangingStatus = true;
    try {
      await this.commentAdd(comment);
      await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Status, change: StatusDeclarationEnum.NotApplicable });
      document.body.classList.remove('modal-open');
      await this.router.navigate(['/declarations']);
    } finally {
      this.isChangingStatus = false;
    }
  }

  openCommentModal() {
    this.showCommentModal = true;
    document.body.classList.add('modal-open');
  }

  closeCommentModal() {
    this.showCommentModal = false;
    document.body.classList.remove('modal-open');
  }

  openReactivateModal() {
    this.showReactivateModal = true;
    document.body.classList.add('modal-open');
  }

  closeReactivateModal() {
    this.showReactivateModal = false;
    document.body.classList.remove('modal-open');
  }

  allPhasesSelected() {
    return this.declaration.phases.every(phase => phase.tasks.every(task => task.value || task.isDisabled));
  }


  async setToFinished() {
    if (this.isChangingStatus) return;
    this.isChangingStatus = true;
    try {
      await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Status, change: StatusDeclarationEnum.Finished });
      await this.router.navigate(['/declarations']);
    } finally {
      this.isChangingStatus = false;
    }
  }

  onScroll() {
    if (this.currentPage < this.maxPages) {
      this.currentPage++;
      this.getObservations(this.declaration.id, this.currentPage, this.itemsForPage).then(observations => {
        this.observations = this.observations.concat(observations.observations);
      });
    }
  }

  async setToProgress(comment) {
    await this.commentAdd(comment);
    await this.declarationService.editDeclaration(this.declaration.id, { type: TypeChangeEnum.Status, change: StatusDeclarationEnum.Progress });
    this.isBlocked = false;
    document.body.classList.remove('modal-open');
    this.router.navigate(['/declarations']);
  }

  disableBankAccountAndPresentation(event: { disableBankAccount?: boolean; disablePresentation?: boolean } | boolean) {
    if (typeof event === 'boolean') {
      this.isAccountDisabled = event;
      this.isPresentationDisabled = event;
    } else {
      this.isAccountDisabled = event?.disableBankAccount ?? false;
      this.isPresentationDisabled = event?.disablePresentation ?? false;
    }
  }

  openMultipleExecutorsModal() {
    this.showMultipleExecutorsModal = true;
    document.body.classList.add('modal-open');
  }

  closeMultipleExecutorsModal() {
    this.showMultipleExecutorsModal = false;
    document.body.classList.remove('modal-open');
  }

  async onMultipleExecutorsSave(updates: any[]) {
    // Refresh the declaration data after executors are assigned
    await this.getData(this.declaration.id);
  }

  async openContractObservationsModal() {
    if (!this.declaration?.id) return;
    await this.loadContractObservations();
    this.showContractObservationsModal = true;
    document.body.classList.add('modal-open');
  }

  closeContractObservationsModal() {
    this.showContractObservationsModal = false;
    this.contractObservationForm.reset();
    document.body.classList.remove('modal-open');
  }

  async loadContractObservations() {
    if (!this.declaration?.id) return;
    try {
      // For in-progress declarations, also sync contract-level avisos not yet owned by this declaration
      if (this.declaration.status === 'PROGRESS' && this.declaration?.contract?.id) {
        const [declarationAvisos, contractAvisos] = await Promise.all([
          this.contractObservationsService.getObservationsByDeclaration(this.declaration.id),
          this.contractObservationsService.getContractAvisosForDeclaration(this.declaration.contract.id, this.declaration.id),
        ]);

        const owned = new Set((declarationAvisos || []).map((a: any) => a.comment));
        const unsynced = (contractAvisos || []).filter((a: any) => a.isNotification && !owned.has(a.comment));

        for (const aviso of unsynced) {
          await this.contractObservationsService.createObservation({
            contractId: this.declaration.contract.id,
            declarationId: this.declaration.id,
            userId: this.currentUserId,
            comment: aviso.comment,
            isNotification: true,
          });
        }
      }

      this.contractObservations = await this.contractObservationsService.getObservationsByDeclaration(this.declaration.id);
    } catch (error) {
      console.error('Error loading declaration avisos:', error);
      this.contractObservations = [];
    }
  }

  hasContractNotifications(): boolean {
    return this.contractObservations && this.contractObservations.length > 0;
  }

  async addContractObservation() {
    if (this.contractObservationForm.valid && this.declaration?.id && this.declaration?.contract?.id && this.currentUserId) {
      try {
        await this.contractObservationsService.createObservation({
          contractId: this.declaration.contract.id,
          declarationId: this.declaration.id,
          userId: this.currentUserId,
          comment: this.contractObservationForm.value.comment,
          isNotification: true,
        });
        await this.loadContractObservations();
        this.contractObservationForm.reset();
      } catch (error) {
        console.error('Error adding aviso:', error);
      }
    }
  }

  onBankAccountConfirmationChange(isCompleted: boolean) {
    this.isBankAccountConfirmationCompleted = isCompleted;
    // Si la confirmación está completada, bloquear el input de cuenta bancaria
    if (isCompleted) {
      this.isAccountDisabled = true;
    }
  }

}
